var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaby({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_385",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29207",
    "data-name": "Group 29207",
    transform: "translate(657 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -11197)",
    filter: "url(#Ellipse_385)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385-2",
    "data-name": "Ellipse 385",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17",
    transform: "translate(-635 -11181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49996",
    "data-name": "Path 49996",
    d: "M324.755,330.773H320v-8.322a2.378,2.378,0,0,1,2.378-2.378h2.378Z",
    transform: "translate(-300.979 -297.476)",
    fill: "#23aae6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49997",
    "data-name": "Path 49997",
    d: "M325.35,466.452h-4.755a.594.594,0,0,1-.594-.594v-1.783h4.755a1.189,1.189,0,0,1,1.189,1.189v.594A.594.594,0,0,1,325.35,466.452Z",
    transform: "translate(-300.979 -430.776)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49998",
    "data-name": "Path 49998",
    d: "M152.322,320.074a5.944,5.944,0,0,0-5.944,5.944V328.4H144v3.566a1.189,1.189,0,0,0,1.189,1.189h3.566a4.755,4.755,0,0,0,4.755-4.755v-8.322Z",
    transform: "translate(-138.056 -297.476)",
    fill: "#23aae6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49999",
    "data-name": "Path 49999",
    d: "M64.594,429.225h.594a1.189,1.189,0,0,0,1.189-1.189v-3.963H64.594a.594.594,0,0,0-.594.594v3.963A.594.594,0,0,0,64.594,429.225Z",
    transform: "translate(-64 -393.748)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50000",
    "data-name": "Path 50000",
    d: "M104.322,320.074a5.944,5.944,0,0,0-5.944,5.944V327.8H96v4.161a1.189,1.189,0,0,0,1.189,1.189h3.566a4.755,4.755,0,0,0,4.755-4.755h3.566v2.378h4.755V327.9a5.944,5.944,0,0,0,3.566-5.448v-2.378Z",
    transform: "translate(-93.622 -297.476)",
    fill: "#5ad7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50001",
    "data-name": "Path 50001",
    d: "M277.35,466.452h-4.755a.594.594,0,0,1-.594-.594v-1.783h4.755a1.189,1.189,0,0,1,1.189,1.189v.594A.594.594,0,0,1,277.35,466.452Z",
    transform: "translate(-256.545 -430.776)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 2.378,
    cy: 2.378,
    rx: 2.378,
    ry: 2.378,
    transform: "translate(19.021 20.221)",
    fill: "#ffd205"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50002",
    "data-name": "Path 50002",
    d: "M201.51,64.074a9.51,9.51,0,0,0,0,19.021h3.566a5.944,5.944,0,0,0,5.944-5.944V73.584A9.511,9.511,0,0,0,201.51,64.074Z",
    transform: "translate(-182.49 -60.497)",
    fill: "#fab991"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50003",
    "data-name": "Path 50003",
    d: "M250.972,192.074v5.944a2.972,2.972,0,0,1,0-5.944Z",
    transform: "translate(-234.329 -178.986)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 0.892,
    cy: 0.892,
    rx: 0.892,
    ry: 0.892,
    transform: "translate(20.21 13.088)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 0.892,
    cy: 0.892,
    rx: 0.892,
    ry: 0.892,
    transform: "translate(24.965 13.088)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50004",
    "data-name": "Path 50004",
    d: "M325.151,227.046a.793.793,0,0,1-.793-.793v-2.179a1.585,1.585,0,0,1,1.585,1.585v.594A.792.792,0,0,1,325.151,227.046Zm-3.368-1.189h-1.189a.594.594,0,0,1,0-1.189h1.189a.594.594,0,0,1,0,1.189Zm6.538-.594a.594.594,0,0,0,.594.594h.565c.019-.2.03-.394.03-.594v-.595h-.594A.594.594,0,0,0,328.322,225.263Z",
    transform: "translate(-300.979 -208.608)",
    fill: "#f0915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50005",
    "data-name": "Path 50005",
    d: "M348.98,22.971H348.3a.3.3,0,0,1,0-.594h.682a3.78,3.78,0,0,0,3.776-3.776,2.083,2.083,0,0,0-2.08-2.08,1.488,1.488,0,0,0-1.486,1.486.893.893,0,0,0,.892.892.3.3,0,0,1,0,.594,1.488,1.488,0,0,1-1.486-1.486,2.083,2.083,0,0,1,2.08-2.08A2.678,2.678,0,0,1,353.35,18.6,4.375,4.375,0,0,1,348.98,22.971Z",
    transform: "translate(-326.899 -15.926)",
    fill: "#463c4b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/Baby.efaf0b7ec6c9bff0617699dc0b9ef0ba.svg";
export { ForwardRef as ReactComponent };